import { useEffect, useState } from 'react'
import { joinShowSession } from '../lib/api'
import { useChatStore } from '../state/chatStore'

/**
 * SPEC "Show-Modus für Präsentationen": the staff tablet. It joins the same
 * session as the big screen (pairing code) and sends the questions K4ia then
 * answers on that screen.
 *
 * Deliberately plain: the presenter looks at the room, not at this device.
 */
export function ShowControlPage({ code }: { code: string }) {
  const [status, setStatus] = useState<'joining' | 'ready' | 'failed'>('joining')
  const [text, setText] = useState('')
  const sendMessage = useChatStore((s) => s.sendMessage)
  const messages = useChatStore((s) => s.messages)

  useEffect(() => {
    void joinShowSession(code)
      .then(() => setStatus('ready'))
      .catch(() => setStatus('failed'))
  }, [code])

  async function send(question: string) {
    if (!question.trim()) return
    setText('')
    await sendMessage(question)
  }

  if (status === 'joining') return <p className="p-6 text-text-muted">Verbinde …</p>
  if (status === 'failed') {
    return (
      <main className="p-6">
        <h1 className="mb-2 text-xl font-semibold">Verbindung fehlgeschlagen</h1>
        <p className="text-text-muted">
          Prüfe den Code auf dem Großbildschirm und öffne den Link erneut.
        </p>
      </main>
    )
  }

  return (
    <main className="mx-auto flex min-h-screen max-w-2xl flex-col gap-4 p-6">
      <header>
        <h1 className="text-xl font-semibold">Show-Steuerung · {code}</h1>
        <p className="text-sm text-text-muted">
          Was du hier sendest, beantwortet K4ia auf dem Großbildschirm.
        </p>
      </header>

      <form
        onSubmit={(e) => {
          e.preventDefault()
          void send(text)
        }}
        className="flex gap-2"
      >
        <label htmlFor="show-input" className="sr-only">
          Frage an K4ia
        </label>
        <input
          id="show-input"
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Frage oder Stichwort …"
          className="flex-1 rounded-xl border border-border bg-bg-elevated px-4 py-3 outline-none focus:border-brand"
        />
        <button type="submit" disabled={!text.trim()} className="btn-primary rounded-xl px-5 py-3">
          Senden
        </button>
      </form>

      <section aria-label="Bisher gesendet" className="flex-1 overflow-y-auto">
        <ul className="space-y-2 text-sm">
          {messages
            .filter((m) => m.role === 'user')
            .slice(-15)
            .reverse()
            .map((m) => (
              <li key={m.id} className="rounded-lg border border-border px-3 py-2">
                {m.content}
              </li>
            ))}
        </ul>
      </section>
    </main>
  )
}
